import React, { type FC } from 'react';
import { Form } from 'antd';
import { Modal } from '@g2u/ui-kit';
import { DefaultOptionType } from 'antd/es/select';
import { some, isArray } from 'lodash';

import { type JsonDataItem, type WithOptionalDataTest } from 'types';
import { NotificationsFields } from 'components';

export namespace RequestPaymentModal {
  export type Props = {
    isOpen: boolean;
    emailOptions?: DefaultOptionType[];
    smsOptions?: DefaultOptionType[];
    initialValues?: NotificationsFields.InitialValues;
    onRequest: (data: JsonDataItem) => void;
    onCancel: () => void;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { isOpen, onRequest, onCancel, initialValues, emailOptions, smsOptions } = props;
    const [form] = Form.useForm();
    Form.useWatch([], { form });
    const isValid = some(form.getFieldsValue(), (value) => isArray(value) && value.length > 0);

    const handleFormSubmit = (formData: JsonDataItem) => {
      onRequest(formData);
    };

    return (
      <Modal.$
        open={isOpen}
        destroyOnClose
        maskClosable={false}
        title={'New Payment Request'}
        okText="Send"
        onOk={() => {
          form.submit();
        }}
        okButtonProps={{
          loading: false,
          disabled: !isValid,
        }}
        onCancel={onCancel}
        dataTestId={'request-payment-modal'}
      >
        <Form
          form={form}
          name="request-payment"
          layout="horizontal"
          onFinish={handleFormSubmit}
          colon={false}
          preserve={false}
        >
          <NotificationsFields.$
            isStandalone={false}
            initialValues={initialValues}
            emailOptions={emailOptions}
            smsOptions={smsOptions}
          />
        </Form>
      </Modal.$>
    );
  };
}
